module.exports = __webpack_public_path__ + "img/home_map_Vietnam_lightblue.d1675d72.png";